/*
 * GENERATED — do not edit manually. Run: pnpm gen:components
 * Source: packages/ui-theme/contracts/button.contract.json
 * Styles: @indipia/styles/components.css (토큰 구동 의미 클래스)
 */
import React from 'react';
import { cx } from '../cx';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'etc' | 'ghost' | 'danger' | 'success';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
}

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  className = '',
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cx('btn', `btn-${variant}`, size !== 'md' && `btn-${size}`, loading && 'is-loading', className)}
      {...props}
    >
      {loading && <span className="btn-spinner" aria-hidden="true" />}
      {children}
    </button>
  );
}
